import React from "react";
import { useParams } from "react-router-dom";

import { useQueryGetVocabulary } from "@examspark/common-app";
import { VSpace } from "@examspark/common-ui";

import Breadcrumbs from "../../components/common/Breadcrumbs";
import PageHead from "../../components/common/PageHead";
import VocabularyDetail from "../../components/vocabulary/VocabularyDetail";

const VocabularyRoute = () => {
  const params = useParams<{
    id: string;
  }>();

  const result = useQueryGetVocabulary(params.id ?? "", "vocabulary");
  const { data } = result;

  return (
    <VSpace>
      <PageHead>
        <Breadcrumbs items={Breadcrumbs.Browse()} />
      </PageHead>
      <VocabularyDetail vocabulary={data} />
    </VSpace>
  );
};

export default VocabularyRoute;
